var Component = require("!../../../../../../develop/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../develop/node_modules/vue-loader/lib/selector?type=script&index=0!./Table.vue"),
  /* template */
  require("!!../../../../../../develop/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-228d61a4\",\"hasScoped\":false}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=template&index=0!./Table.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Table.vue
// module id = 212
// module chunks = 0